import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CourseEditor } from "@/features/courses/components/authoring/course-editor";
// AUTONOMY: ajustes por curso (kinds de módulo, escala, proveedor de vivo, media).
import { CourseSettingsPanel } from "@/features/academy/components/course-settings-panel";

function AuthoringCoursePage() {
  const params = useParams({ from: "/u/$u/authoring/$courseId" });
  return (
    <>
      <CourseEditor courseId={params().courseId} />
      <div class="mx-auto max-w-5xl px-4 pb-8">
        <CourseSettingsPanel courseId={params().courseId} />
      </div>
    </>
  );
}

export const authoringCourseRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/authoring/$courseId",
  component: AuthoringCoursePage,
});
